import MultipleInput from "../elements/MultipleInput";
import { useEffect, useState } from "react";
import { BASE_URL, CROP_LIST, DEFAULT_DATA_ITEM, DEFAULT_DATA_ITEM_ARRAY, TypeDataItem, TypeDataSource, TypeValueChain } from "../../helpers/constants";
import useApiRequest from "../../helpers/api_request";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAccessToken } from "../../features/auth/authSlice";
import AppButton from "../elements/AppButton";
import { useNavigate, useParams } from "react-router-dom";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useProcessingData } from "../../hooks/useProcessingData";
import AppSpinner from "../elements/AppSpinner";
import { TypeProductionData } from "../production/CreateProductionPage";


export type TypeProcessingData = {
    "value_chain_id"?: string,
    "year": string,
    "no_of_warehouses": TypeDataItem,
    "qty_bought_by_millers": TypeDataItem,
    "no_of_processing_plants": TypeDataItem,
    "qty_processed": TypeDataItem,
    "no_of_processing_standards": TypeDataItem,
    "take_of_price": TypeDataItem,
    "list_of_products": TypeDataItem,
    "no_of_processors": TypeDataItem,
    "no_of_washing_stations": TypeDataItem,
    "list_of_varieties_processed": TypeDataItem,
    "created_at"?: string,
    "value_chain": string,
    "_id"?: string
}

const DEFAULT_VALUES = {
    "value_chain_id": "",
    "value_chain": "",
    "year": "",
    "no_of_warehouses": DEFAULT_DATA_ITEM,
    "qty_bought_by_millers": DEFAULT_DATA_ITEM,
    "no_of_processing_plants": DEFAULT_DATA_ITEM,
    "qty_processed": DEFAULT_DATA_ITEM,
    "no_of_processing_standards": DEFAULT_DATA_ITEM,
    "take_of_price": DEFAULT_DATA_ITEM,
    "list_of_products": DEFAULT_DATA_ITEM_ARRAY,
    "no_of_processors": DEFAULT_DATA_ITEM,
    "no_of_washing_stations": DEFAULT_DATA_ITEM,
    "list_of_varieties_processed": DEFAULT_DATA_ITEM_ARRAY
}

const CreateProcessingPage = () => {
    const [dataSources, setDataSources] = useState<TypeDataSource[] | []>([]);
    const apiRequest = useApiRequest();
    const accessToken = useAppSelector(selectAccessToken);
    const [valueChains, setValueChains] = useState<TypeValueChain[] | []>([]);
    const [isSavingData, setIsSavingData] = useState(false);
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const [processingData, setProcessingData] = useState<TypeProcessingData>(DEFAULT_VALUES);
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - i);
    const { id } = useParams();
    const { loadingData, processingData: processingDataList, getProcessingData } = useProcessingData();


    useEffect(() => {
        if (id != undefined) {
            if (processingDataList.length > 0) {
                const record = processingDataList.filter((item) => item._id == id)[0]
                for (const key in record) {
                    const field = record[key as keyof TypeProcessingData]
                    setProcessingData((prevProcessingData) => ({
                        ...prevProcessingData,
                        [key]: field,
                    }));
                }
                addToDataSources(record)
            }
        }
    }, [processingDataList])

    const addToDataSources = (record: TypeProcessingData) => {
        const otherDataSources:TypeDataSource[] = []
        for (const key in record) {
            const field = record[key as keyof TypeProcessingData]
            if (typeof field == "object") {
                if (field) {
                    const dataSource = {
                        id: null,
                        name: field.data_source
                    }
                    otherDataSources.push(dataSource)
                }
            }
        }
        const uniqueValues = otherDataSources.filter(
            (item, index, self) =>
                index === self.findIndex((i) => i.name === item.name)
        );
        setDataSources((prev)=> [...prev, ...uniqueValues])
    }

    useEffect(() => {
        if (id != undefined) {
            getProcessingData();
        }
    }, []);

    useEffect(() => {
        getDataSources()
        getValueChains()

    }, [])

    const saveProcessingData = async () => {
        if (processingData.value_chain === "") {
            dispatch(showToastMessage({
                message: "Value chain is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return
        }

        setIsSavingData(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/processing/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: processingData
        }).then((response) => {
            setIsSavingData(false)
            dispatch(showToastMessage({
                message: "Processing data Saved",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            navigate("/processing")
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setIsSavingData(false)
        });
    }

    const getValueChains = async () => {
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/value-chain",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setValueChains(response.data)
        }).catch((error) => {

        });
    }

    const getDataSources = async () => {
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/data-source",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setDataSources((prev)=>[...prev, ...response.data])
        }).catch((error) => {

        });
    }

    const setDataItemValue = (field: keyof TypeProcessingData, value: string | string[]) => {
        setProcessingData({
            ...processingData,
            [field]: {
                ...processingData[field] as TypeDataItem, value: value
            }
        });
    }

    const setDataItemSource = (field: keyof TypeProcessingData, data_source: string | string[]) => {
        setProcessingData({
            ...processingData,
            [field]: {
                ...processingData[field] as TypeDataItem, data_source: data_source
            }
        });
    }



    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Processing</h5>
                                    </div>
                                </li>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">{id ? "Edit" : "Create"}</h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    {(loadingData) && <AppSpinner TopClass=" flex pt-0" />}
                    <div className=" h-fit flex-grow flex flex-col justify-center ">
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">Value Chain</label>
                            <select value={processingData.value_chain} onChange={(e) => setProcessingData({ ...processingData, value_chain: e.target.value })} className="form-input-2" name="" id="">
                                <option value="">--Select--</option>
                                {valueChains.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                            </select>
                        </div>

                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">Year</label>
                            <select value={processingData.year} onChange={(e) => setProcessingData({ ...processingData, year: e.target.value })} className="form-input-2" name="" id="">
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">No of warehouses</label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.no_of_warehouses.value} onChange={(e) => setDataItemValue('no_of_warehouses', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.no_of_warehouses.data_source} onChange={(e) => setDataItemSource('no_of_warehouses', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 "> No of Certified Milling/processing plants</label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.no_of_processing_plants.value} onChange={(e) => setDataItemValue('no_of_processing_plants', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.no_of_processing_plants.data_source} onChange={(e) => setDataItemSource('no_of_processing_plants', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="w-2/3 mt-4 ">
                            <label className="block text-sm font-medium text-gray-700 "> Qty bought by millers</label>
                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.qty_bought_by_millers.value} onChange={(e) => setDataItemValue('qty_bought_by_millers', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.qty_bought_by_millers.data_source} onChange={(e) => setDataItemSource('qty_bought_by_millers', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 "> Qty processed (Kgs)</label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.qty_processed.value} onChange={(e) => setDataItemValue('qty_processed', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.qty_processed.data_source} onChange={(e) => setDataItemSource('qty_processed', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">No of processing standards </label>
                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.no_of_processing_standards.value} onChange={(e) => setDataItemValue('no_of_processing_standards', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.no_of_processing_standards.data_source} onChange={(e) => setDataItemSource('no_of_processing_standards', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">Off take price (UGX) </label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.take_of_price.value} onChange={(e) => setDataItemValue('take_of_price', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.take_of_price.data_source} onChange={(e) => setDataItemSource('take_of_price', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">List of products</label>
                            <div className="grid grid-cols-2 gap-2">
                                <MultipleInput inputValues={processingData.list_of_products.value as string[]} getValues={(values) => setDataItemValue('list_of_products', values)} />
                                <div>
                                    <select value={processingData.list_of_products.data_source} onChange={(e) => setDataItemSource('list_of_products', e.target.value)} className="form-input-2" name="" id="">
                                        <option value="">--Select Source--</option>
                                        {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">No of processors</label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.no_of_processors.value} onChange={(e) => setDataItemValue('no_of_processors', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.no_of_processors.data_source} onChange={(e) => setDataItemSource('no_of_processors', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">No of washing stations.</label>

                            <div className="grid grid-cols-2 gap-2">
                                <input value={processingData.no_of_washing_stations.value} onChange={(e) => setDataItemValue('no_of_washing_stations', e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                <select value={processingData.no_of_washing_stations.data_source} onChange={(e) => setDataItemSource('no_of_washing_stations', e.target.value)} className="form-input-2" name="" id="">
                                    <option value="">--Select Source--</option>
                                    {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 "> List of varieties processed .</label>
                            <div className="grid grid-cols-2 gap-2">
                                <MultipleInput inputValues={processingData.list_of_varieties_processed.value as string[]} getValues={(values) => setDataItemValue('list_of_varieties_processed', values)} />
                                <div>
                                    <select value={processingData.list_of_varieties_processed.data_source} onChange={(e) => setDataItemSource('list_of_varieties_processed', e.target.value)} className="form-input-2" name="" id="">
                                        <option value="">--Select Source--</option>
                                        {dataSources.map((item, key) => <option key={key} value={item.name}>{item.name}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="w-2/3 mt-4">
                            <AppButton callBackFun={() => saveProcessingData()} showLoader={isSavingData} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2 mb-2" text="Save" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateProcessingPage;